import Nullstack from 'nullstack';
export default function IconWashDry3({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wash-dry-3",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "6"
  }), "   ", Nullstack.element("path", {
    d: "M12 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M9 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 12h.01"
  }), " ");
}